// removed by extract-text-webpack-plugin
module.exports = {"visible-xs":"visible-xs___1lAAi","visible-sm":"visible-sm___Yx3vC","visible-md":"visible-md___3A7Pp","visible-lg":"visible-lg___3wOxQ","row":"row___1VfgF","hidden-xs":"hidden-xs___1pvvG","hidden-sm":"hidden-sm___2rJbU","hidden-md":"hidden-md___2fg9P","hidden-lg":"hidden-lg___1UkMK","main":"main___2SRnQ page___2ZhHk"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/FundRedirect/FundRedirect.css
// module id = 890
// module chunks = 0